import { apiMethods } from '../methods'

export const ParkingBaseURL = process.env.REACT_APP_PARKING
export const baseURL = process.env.REACT_APP_BASENAME

export const getEnv = async () => {
  return await apiMethods.noAuthGet({ url: baseURL })
}
